// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".license-order-detail[data-v-bdf726f8] {\n  height: 100%;\n  overflow: auto !important;\n}\n.license-order-detail .account-list[data-v-bdf726f8] {\n  padding: 0.53333rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
